import React, { useState } from 'react';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ForceChangePassword from './components/ForceChangePassword';
import AdminApp from './AdminApp';

export default function App() {
  const [token,               setToken]               = useState(localStorage.getItem('token'));
  const [forcePasswordChange, setForcePasswordChange] = useState(
    localStorage.getItem('force_password_change') === 'true'
  );

  // Route /admin → admin portal
  const isAdmin = window.location.pathname.startsWith('/admin');
  if (isAdmin) return <AdminApp />;

  const handleLogin = (data) => {
    localStorage.setItem('token',                data.access_token);
    localStorage.setItem('client_code',          data.client_code);
    localStorage.setItem('name',                 data.name);
    localStorage.setItem('force_password_change', data.force_password_change ? 'true' : 'false');
    setForcePasswordChange(!!data.force_password_change);
    setToken(data.access_token);
  };

  const handleLogout = () => {
    localStorage.clear();
    setToken(null);
    setForcePasswordChange(false);
  };

  const handlePasswordChanged = () => {
    localStorage.setItem('force_password_change', 'false');
    setForcePasswordChange(false);
  };

  if (!token) return <Login onLogin={handleLogin} />;

  if (forcePasswordChange) return (
    <ForceChangePassword
      onDone={handlePasswordChanged}
      onLogout={handleLogout}
    />
  );

  return <Dashboard onLogout={handleLogout} />;
}
